module.exports = __webpack_public_path__ + "p1_img2.jpg?09761d329e7877cea5ae8c3be4936d01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img2.jpg
// module id = 112
// module chunks = 0